module.exports = __webpack_public_path__ + "img/9dc8f.14bfb3e2.svg";